var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-btn',{on:{"click":_vm.addPower}},[_vm._v("power")]),_c('p',{ref:"para",attrs:{"word-break":"keep-all"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }